export default {
  notice: {
    progress: '{done} of {total} places marked',
    participation_hint: 'A few steps left to complete your places.',
    participation_unfinished: 'Your participation is not finished yet'
  },
  home_tiles: {
    preset_demo: 'Recommended',
    preset_weide: 'Meadow',
    preset_app: 'App',
    preset_speels: 'Playful',
    layout_game: 'Game',
    layout_poster: 'Poster',
    depth_demo: 'Depth',
    depth_flat: 'Flat',
    depth_soft: 'Soft',
    depth_deep: 'Deep',
    demo_panel: 'Demo options',
    notice_demo: 'Participation banner',
    notice_progress: 'Progress',
    notice_bold: 'Bold',
    notice_boldprogress: 'Bold + progress',
    notice_boldfull: 'Bold + text + progress',
    bg_demo: 'Background',
    bg_plain: 'White',
    bg_soft: 'Soft',
    bg_meadow: 'Meadow',
    banner_welcome: 'Welcome',
    layout_welcome: 'Welcome',
    welcome_intro: 'You follow {communities} communities and have marked {areas} areas.',
    banner_demo: 'Header',
    banner_solid: 'Solid',
    banner_photo: 'Photo',
    banner_minimal: 'Minimal',
    banner_pass: 'Member pass',
    areas_count: '{count} areas',
    communities_count: '{count} communities',
    budget_line: '{amount} budget · {pct}% pledged',
    layout_demo: 'Tile layout',
    layout_inline: 'Inline',
    layout_icon: 'Icon',
    layout_compact: 'Compact',
    subscribers: '{count} subscribers',
    hello: 'Hi {name}',
    notifications: 'Notifications',
    unread: '{count} unread',
    all_read: 'All caught up',
    no_messages: 'No messages yet',
    see_all: 'See all',
    budget: 'Budget',
    pledged: 'pledged',
    no_budget: 'No nature budget yet',
    no_areas: 'No areas yet. Mark places you care about on the map.',
    no_communities: 'Not subscribed to a community yet.',
    browse_map: 'Browse map'
  },
  theme: {
    title: 'Theme',
    modern_light: 'Light',
    modern_dark: 'Dark',
    neon: 'Neon',
    glass: 'Glass'
  },
  messages: {
    // account_created: 'Please check your email to verify your registration. This sometimes can take up to 10 minutes. Please check the spam folder if the email has not been received.',
    // password_forgot: 'Please check your email to reset your password.',
    // verification_success: 'Your e-mail has been verified. You can now login.',
    // verification_failed: 'Verification has failed.',
    // password_recover_success: 'Your password has been reset. You can now login with the new password.',
    // logout_confirmation: 'Are you sure you want to log out?',
    // confirm: 'Confirm',
    // update_available: 'A new update is available. Click on ok to reload the page.',
    // account_signed_out: 'You have been signed out',
    // account_updated: 'Account succesfully updated'
    account_created: 'Account successfully created',
    password_forgot: 'Please check your email to reset your password.',
    account_signed_out: 'You have been signed out',
    account_updated: 'Account succesfully updated',
    verification_success: 'Your e-mail has been verified. You can now login.',
    verification_failed: 'Verification has failed.',
    password_recover_success: 'Your password has been reset. You can now login with the new password.',
    logout_confirmation: 'Are you sure you want to log out?',
    login_confirmation: 'You have succesfully signed in. Welcome back!',
    login_failed: 'Email and password combination not recognised',
    confirm: 'Confirm',
    update_available: 'A new update is available. Click on ok to reload the page.',
    url_copied_to_clipboard: 'The map url has been copied to clipboard',
    add_area_account_required: 'To add a new area you\'re required to have an account.',
    area_deleted: 'Area has been removed',
    area_updated: 'Area has been updated',
    unsubscribed: 'You have been unsubcribed from the community',
    subscribed: 'You are now part of this community',
    thread_created: 'A new thread has been created',
    thread_updated: 'Discussion has been updated',
    comment_created: 'You have posted a reply',
    comment_reported: 'This content has been flagged for moderation',
    comment_unreported: 'This content has been cleared by moderation',
    comment_deleted: 'This content has been deleted',
    community_updated: 'This community has been updated',
    RMS_send: 'Moderator request has been sent',
    poll_created: 'Poll created',
    polis_created: 'Polis created',
    meeting_created: 'Meeting created',
    meeting_invite_accepted: 'You have accepted the invite',
    meeting_invite_declined: 'You have declined the invite',
    pledge_funding_completed: 'Virtual pledge funding succesfully completed',
    pledge_added: 'Thank you for your pledge of € ',
    pledge_rejected: 'Thank you for your elaboration'
  },
  errors: {
    general_error: 'An error occured. Please try again.',
    not_found: 'Sorry, nothing here...',
    network: 'Network error. Please check your internet connection',
    // fields: 'Please correct the input fields',
    required: 'Required field',
    register: {
      password_length: 'The minimum length of the password is {length} characters.',
      password_match: 'Passwords do not match.',
      email_valid: 'A valid email address is required',
      name_length: 'Display name length between {minLength} and {maxLength} characters ',
      organization_length: 'Organization name length between {minLength} and {maxLength} characters '
    }
  },
  buttons: {
    pledge: 'Pledge',
    ok: 'Ok',
    submit: 'Submit',
    logout: 'Logout',
    cancel: 'Cancel',
    login: 'Login',
    register: 'Submit',
    // go_back: 'Go back',
    send: 'Send',
    reSend: 'Resend',
    close: 'Close',
    previous: 'Previous',
    save: 'Save',
    create: 'Create',
    update: 'Update',
    delete: 'Remove',
    subscribe: 'Subscribe',
    unsubscribe: 'Unsubscribe',
    next: 'Next',
    continue: 'Continue',
    back: 'Back',
    add: 'Add',
    edit: 'Edit',
    reply: 'Reply',
    report: 'Report',
    unreport: 'Unreport',
    goto_authenticate: 'To sign in',
    stop: 'Stop',
    pauze: 'Pauze',
    continue_register: 'Continue registration',
    continue_participation: 'Continue participation',
    become_moderator: 'Become moderator',
    add_image: 'Add image',
    accept: 'Accept',
    decline: 'Decline',
    reset: 'Reset',
    discard: 'Discard'
  },
  headers: {
    login: 'Login',
    register: 'Register',
    password_forgot: 'Request a new password',
    password_recover: 'Reset password',
    administrator: 'Administrator',
    navigation: 'Navigation',
    my_overview: 'My overview',
    overview: 'Overview',
    users: 'Users',
    communities: 'Communities'
  },
  activities: {
    act_cycl: {
      title: 'Cycling',
      desciption: 'TODO'
    },
    act_walk: {
      title: 'Walking or running',
      desciption: 'TODO'
    },
    act_tour: {
      title: 'Touring by car or motor',
      desciption: 'TODO'
    },
    act_natu: {
      title: 'Watching nature',
      desciption: 'TODO'
    },
    act_water: {
      title: 'Water sports',
      desciption: 'TODO'
    },
    act_play: {
      title: 'Playing or sitting',
      desciption: 'TODO'
    },
    act_wintr: {
      title: 'Winter sports',
      desciption: 'TODO'
    },
    act_mount: {
      title: 'Mountain sports',
      desciption: 'TODO'
    }
  },
  labels: {
    account_required: 'Account required',
    read_more: 'read more',
    'area_create_button': 'Save',
    'area_update_button': 'Save',
    'area_created_succes': 'Area is succesfully created',
    'area_updated_succes': 'Area is succesfully updated',
    'community_created_succes': 'Community is succesfully created',
    agree_disclaimer: 'I agree with these terms',
    my_account: 'My account',
    register: 'Create account',
    logout: 'Sign out',
    login: 'Sign in',
    email: 'Email address',
    name: 'Display name',
    companyName: 'Company name',
    organization: 'Organization name',
    sector: 'Sector',
    address: 'Address',
    address_search: 'Home',
    // zipcodeCompany: 'Zipcode headquarter',
    website: 'Webpage',
    city: 'City',
    // cityCompany: 'City headquarter',
    age: 'Age group',
    education: 'Education',
    gender: 'Gender',
    type: 'Type',
    password: 'Password',
    repeat_password: 'Repeat password',
    remember_me: 'Remember me',
    password_forgot: 'Forgot your password?',
    home: 'Home',
    here: 'here',
    neighbourhood: 'neighbourhood',
    'living-area': 'region',
    country: 'country',
    worldwide: 'worldwide',
    share_this_area: 'Share this area',
    share_this_community: 'Share this community',
    subscribed: 'Subscribed',
    reply: 'Reply',
    comment: 'Comment',
    finish: 'Finish',
    readmore: 'read more',
    search: 'search',
    created_on: 'created_on',
    dear: 'Dear',
    karma: 'Karma'
  },
  pages: {
    home: {
      title: 'Home'
    },
    moderators: {
      title: 'Moderators',
      mod_requests: 'Moderator requests',
      mods: 'Moderators'
    },
    create_community: {
      title: 'Create community'
    },
    land_owner_register: {
      title: 'Land owner registration',
      steps: {
        general: {
          nav_title: ' General info',
          title: 'Land owner information',
          task_title: 'Proveide general information for the land you own',
          email: 'Email'
        },
        draw: {
          nav_title: 'Map',
          title: 'Draw area',
          task_title: 'Draw your area'
        },
        description: {
          nav_title: 'Description',
          title: 'Describe your community',
          task_title: 'Provide a title that represents your community',
          input_title: 'Titel',
          input_title_error: 'Maximum of 50 characters',
          input_description: 'Description',
          task_description: 'Describe what makes this particular community attractive, valuable or important',
          input_description_error: 'Maximum of 1000 characters'
        },
        finalize: {
          nav_title: 'Finalize',
          title: 'Information',
          task_title: 'Thank you for supplying this information, if you click next we will finalize your community. To discuss topics with your community you can open a thread. Click on the 3 dots to the right of \'threads\' to add a new thread and discuss a new topic.'
        }
      }
    },
    pledge: {
      count: 'Total number of pledgers',
      part1: 'pledged of',
      part2: 'goal',
      question: 'Would you like to <b>pledge</b> your virtual funds to this project?',
      yes: 'Yes, I <b>do</b> want to pledge to this project',
      no: 'No, I <b>don\'t</b> want to pledge to this project'
    },
    add_pledge: {
      title_nav: 'Add Pledge',
      title: 'Provide the amount of funding you would like to pledge to this project.',
      description: 'todo text',
      amount: 'Amount',
      reason: 'Would you please elaborate on why you have chosen this amount?',
      reasonNo: 'Would you please elaborate why you don\'t want to pledge to this project?',
      confirm_text1: 'You are currently proposing to pledge',
      confirm_text2: 'of your indicated yearly nature budget to this project. Would you kindly confirm this amount?',
      confirm: 'I confirm'
    },
    add_treasure: {
      title_nav: 'Add Treasure',
      photos: 'Photos',
      title: 'Upload photos of treasures',
      description: 'Picture why you love this place. Share a drawing, a poem, a picture or a short story.',
      upload: 'Upload photos (.jpg)'
    },
    create_pledge: {
      title_nav: 'Add pledge',
      title: 'Describe your financing request with one catchy title.',
      description: 'Describe your financing request in more detail. Provide background information, proposed actions, envisioned results and what your pledgers will receive in return.',
      type: 'Pledge type',
      fixed: 'Fixed',
      fixed_desc: 'Request for one-time funding',
      yearly: 'Yearly',
      yearly_desc: 'Request for funding repeating yearly',
      '2yearly': '2-Yearly',
      '2yearly_desc': 'Request for funding repeating every 2 years',
      '3yearly': '3-Yearly',
      '3yearly_desc': 'Request for funding repeating every 3 years',
      '4yearly': '4-Yearly',
      '4yearly_desc': 'Request for funding repeating every 4 years',
      '5yearly': '5-Yearly',
      '5yearly_desc': 'Request for funding repeating every 5 years',
      goal: 'State your pledge goal in euros.'
    },
    edit_pledge: {
      title_nav: 'Edit pledge'
    },
    create_message: {
      title_nav: 'Create message',
      steps: {
        community: {
          nav_title: 'Community',
          title: 'Select the <b>community</b> to sent the message to its <b>all fans</b> ect</p>'
        },
        message: {
          nav_title: 'Message'
        },
        finalize: {
          nav_title: 'Finalize'
        }
      }
    },
    create_thread: {
      title_nav: 'Create discussion',
      title_nav_edit: 'Edit discussion',
      title: 'Provide a title',
      description: 'Provide a first post',
      upload: 'Upload photos (.jpg)'
    },
    create_poll: {
      title_nav: 'Create Poll',
      title_nav_edit: 'Edit Poll',
      title: 'Provide a title',
      description: 'Provide a first post',
      upload: 'Upload photos (.jpg)',
      options: 'Add poll options',
      option: 'option'
    },
    create_polis: {
      title_nav: 'Create Polis',
      title_nav_edit: 'Edit Polis',
      title: 'Provide a title',
      id: 'Provide a polis ID',
      voter_option: 'Only subscribed users can vote'
    },
    create_meeting: {
      title_nav: 'Create Polis',
      title_nav_edit: 'Edit Polis',
      title: 'Provide a title',
      description: 'Provide a description',
      url: 'Provide external url of meeting',
      dateTime: 'Start time & date'
    },
    meeting: {
      total_subs: 'Total subscribers',
      accepted_invites: 'Accepted Invites',
      rejected_invites: 'Rejected Invites',
      planned_label: 'planned on',
      invited_banner: 'You have been invited for the meeting',
      accepted_banner: 'You have accepted the invite, if you are selected you will be emailed with further details about the meeting.',
      rejected_banner: 'You have declined the invite for the meeting',
      send_banner: 'Send the link of the meeting to subscribers that have accepted the invite.',
      resend_banner: 'Resend the link of the meeting. Warning you have already send the links!'
    },
    landing: {
      my_portal: 'My Xena'
    },
    welcome: {
      title: 'Welcome to Greenmapper',
      introduction: 'Introduction',
      subtitle_1: 'Mark nature and landscape places',
      paragraph_1: 'In Greenmapper Friends you can mark <b>nature or landscape</b> places with <b>green and/or water</b> that you find <b>attractive, valuable, or important</b>. A place can be small or large, in or outside a city or village. You may visit it often, rarely, or mainly know it from stories or photos.',
      subtitle_2: 'Why register?',
      paragraph_2: 'Your marked place is a place you can be an <b>online friend</b> of. That’s why we ask a few details to create an account. Only your <b>screen name</b> is visible to other users.',
      subtitle_3: 'Privacy policy',
      paragraph_3: 'Greenmapper Friends is an initiative of the University of Groningen. Greenmapper Friends stores your emailaddress in the Greenmapper Landscape Friend Registry (GLFR). No one can access this email accept the Greenmapper organisation. You can via the GLFR be reached anonymously by land-owners, land management, or other friends of the area. But these third parties do not have direct access to your email. We follow the European General Data Protection Regulation guidelines for privacy and the storage of your personal data.',
      continue_without_account: 'Continue without account',
      login_text: 'If you already have an account, you can sign in',
      forgot_password: 'Forgot password?',
      forgot_password_dialog: 'Please enter your email address.'
    },
    introduction: {
      title: 'Introduction',
      text: 'In Greenmapper Friends, you can <b>mark nature</b> or <b>landscape places</b> that you find <b>attractive, valuable, or important</b>. These areas have to be places with greenery, water or nature. You can think of a place in a park, at a lake, at sea, in a forest, a meadow, a field of flowers, a spot to watch birds etc. It can be a place within or outside a city or town, small or large. You may visit them often or never! As long as it is a natural place that you find attractive or valuable or is meaningful for you.',
      start_btn: 'Start survey'
    },
    register: {
      email_sublabel: 'not visible to others',
      name_sublabel: 'visible to others',
      name_hint: 'for example a nickname or first name',
      address_search_sublabel: '±200 m near your home is enough',
      password_hint: 'minimum 8 characters',
      map_preview_hint: 'Select a home location to preview it on the map',
      use_my_location: 'Use my location',
      geolocate_failed: 'Could not get your location. Check permissions or search instead.',
      location_not_found: 'No location found for that search. Try a city, address, or postcode.',
      disclaimer_title: 'Disclaimer Greenmapper Friends',
      disclaimer: 'Greenmapper Friends stores your email address in the Greenmapper Landscape Friend Registry (GLFR). No one can access this email accept Greenmapper Friends. You can via the GLFR be reached anonymously by land-owners, land management, or other friends of the area. But these third parties do not have direct access to your email or personal data. We also ask your home location. We only do this to show you a map of your surroundings by default. We follow the European General Data Protection Regulation guidelines for privacy and the storage of your personal data. Read more details'
    },
    info_contact: {
      title: 'About',
      contact: 'Contact',
      disclaimer_title: 'Disclaimer',
      implementation: 'Implementation: '
    },
    map: {
      title: 'Overall community map',
      add_btn: 'Draw a new area',
      share_title: 'Share map url',
      share_btn: 'Copy to clipboard',
      hint_on_add: 'Place the dot on the map to start drawing',
      hint_on_end_draw: 'You can still modify the area.',
      zoom_to_area_btn: 'Zoom to area',
      details_btn: 'View details' // share_desc: 'Share'

    },
    timeline: {
      title: 'Timeline',
      hint: 'Did you know that the most popular activity in favourite natural places is walking?',
      rating: 'Rating',
      rating_subtext: 'Personal rating of the marked area',
      visit_frequency: 'Visit frequency',
      visit_frequency_subtext: 'How often the area is visited',
      activities: 'Activities',
      activities_subtext: 'Activities reported at marked area',
      add_btn: 'Add an area',
      edit_btn: 'Edit area',
      delete_btn: 'Remove area',
      delete_title: 'Remove area',
      delete_subtitle: 'Are your sure?'
    },
    add_area_info: {
      title: 'Add area',
      add_btn: 'Add an area'
    },
    my_areas: {
      title: 'My areas',
      sub_title: 'All the nature related places I find attractive, valuable or important.',
      created_areas: 'Created areas',
      joint_surface: 'Joint surface (km2)',
      and_section_eyebrow: 'Greenmapper Attractive Nature Database',
      and_section_title: 'Your four scale favorite places',
      and_complete_badge: 'All four scales complete',
      free_section_title: 'Places you added yourself'
    },
    my_communities: {
      title: 'My communities',
      sub_title: 'All the areas of land owners or land management that overlap with my areas. Here I can be reached as a friend of those areas.',
      delete_btn: 'Unsubscribe',
      delete_title: 'Unsubscribe',
      delete_subtitle: 'Are you sure you want to unsubscribe from this community?',
      befriended_communities: 'Befriended communities',
      joint_surface: 'Joint surface (km2)'
    },
    info: {
      text1: 'Greenmapper Friends is developed by Greenmapper. For more information please have a look at the Greenmapper',
      text2: 'If you have any questions or you want to contact us, please drop us an email at:',
      text3: 'With Greenmapper Friends we try to keep the  application and data as accurate and free of errors as possible. Should the app -despite our efforts- contain incomplete or inacurate information, then we cannot accept responsibility for that.',
      text4: 'We reserve the right to change, remove or add material without any prior notice. Greenmapper Friends  accepts no liability for any information contained on websites to which we refer via hyperlinks.'
    },
    my_owned_communities: {
      title: 'My communities',
      owned_communities: 'Owned communities',
      total_subs: 'Total subscribers',
      joint_surface: 'Joint surface (km2)'
    },
    community: {
      report_title: 'Report content',
      report_subtitle: 'Are you sure you want to report this content for moderation?',
      report_hint: 'Type a reason',
      delete_title: 'Delete content',
      delete_subtitle: 'Are you sure you want to delete this content?',
      discussions_title: 'Discussions',
      discussions_subtitle: 'Open discussion on any topic',
      poll_title: 'Poll',
      poll_subtitle: 'Simple polling and voting for options',
      polis_title: 'Polis',
      polis_subtitle: 'Click on one of the subjects below to start pol.is polling',
      pledges_title: 'Support projects!',
      pledges_subtitle: 'Virtually pleding of funds for biodiversity, landscape quality or sustainable services',
      meetings_title: 'Meetings',
      meetings_subtitle: 'In-depth online workshop or council of friends',
      RMS_dialog_title: 'Request moderator status',
      RMS_dialog_text: 'Do you want to send a request to become moderator for this community?'
    },
    polis: {
      text: 'Click "Active third-party translation" to see the comments in your default language. For each statement, you can vote ‘agree’, ‘disagree’ or ‘pass/unsure’.',
      text2: 'You can submit your opinion or statement, so others can vote on your ideas.'
    },
    account: {
      edit_title: 'Edit profile',
      edit_text: 'Edit your current profile information',
      edit_btn: 'Edit profile',
      signout_title: 'Sign out',
      signout_text: 'Sign out of your account',
      signout_btn: 'Sign out'
    },
    set_home: {
      title: 'Home',
      popup_title: 'Where do you live?',
      popup_text: 'Drag the pin to the vicinity of your home (±200 m)'
    },
    create_area: {
      title: 'Create area',
      add_title: 'Add area',
      home_title: 'Place home marker',
      pauze_title: 'Are you sure?',
      pauze_text: 'Pauze the registration and continue later',
      map_tips: 'Map tips',
      search_place: 'Search for a place',
      search_not_found: 'Nothing has been found',
      zoom_smaller: 'Smaller',
      zoom_bigger: 'Bigger',
      area_reset: 'Area reset',
      reset_polygon: 'Reset polygon',
      reset_polygon_title: 'Reset polygon?',
      reset_polygon_text: 'This restores the polygon to how it looked before you started editing.',
      leave_polygon_edit_title: 'Leave polygon edits?',
      leave_polygon_edit_text: 'Going back resets your polygon to the circle selection. Your point edits will be lost.',
      polygon_guard: {
        cross: 'Lines must not cross',
        spacing: 'Points must not get too close',
        edge: 'Point must not get too close to another side',
        angle: 'Corner cannot become that sharp',
        area: 'Area cannot become that small',
        bounds: 'Point stays within the visible map area'
      },
      loading: {
        title: 'Preparing map',
        opening: 'Opening map…',
        loading_account: 'Loading account…',
        loading_areas: 'Loading your areas…',
        loading_home: 'Loading home…'
      },
      hints: {
        place_above_area: 'Place over your area',
        place_area_here: 'Place fully inside',
        drag_vertex: 'Drag points to fit your place',
        zoom: 'Zoom in and out',
        at_edge: 'You have reached the edge of this area'
      },
      stepper: {
        description: 'Description',
        rate: 'Rating',
        visit_freq: 'Visiting frequency',
        activities: 'Activities',
        connected: 'Online connected'
      },
      steps: {
        level: {
          nav_title: 'Level',
          title: 'Choose level',
          task_title: 'select your level of area',
          options: {
            neighborhood: 'neighborhood / local',
            living_area: 'region / regional',
            country: 'country',
            world: 'world'
          }
        },
        map: {
          nav_title: 'Map',
          title: 'Draw area',
          task_title: 'Draw your area'
        },
        description: {
          nav_title: 'Describe',
          title: 'Describe your area',
          task_title: 'What do you call this area?',
          input_title: 'Titel',
          input_name: 'Name',
          input_title_error: 'Maximum of 50 characters',
          input_description: 'Description',
          task_description: 'Why is this area attractive, valuable and/or important?',
          input_description_error: 'Maximum of 1000 characters'
        },
        rate: {
          nav_title: 'Rating',
          title: 'Rate your area',
          task_title: '(Score: 1 = bad, 6 = average, 10 = perfect)'
        },
        visit_freq: {
          nav_title: 'Visit',
          title: 'How often do you vistit your area?',
          options: {
            daily: 'Daily',
            weekly: 'Weekly',
            monthly: 'Monthly',
            few_times_a_year: 'Few times a year',
            yearly: 'Yearly',
            rarely: 'Rarely',
            never: 'Never'
          }
        },
        activities: {
          nav_title: 'Activities',
          title: 'What activities do you engage in at this area?'
        },
        priority: {
          nav_title: 'Priority',
          title: 'Should this place be:',
          options: {
            maintained: 'Maintained (= keep it as it is)',
            strengthened: 'Strengthened (= improve its qualities)'
          }
        },
        relationship: {
          nav_title: 'Relation',
          title: 'What is your relationship to this area',
          options: {
            tourist: 'Tourist',
            inhabitant: 'Inhabitant',
            work: 'Work-related'
          }
        },

        /*
                        finished: {
                            '1_title': 'Thank you! Your first place is now on the map',
                            '1_text': 'Even this first contribution already helps us better understand which natural places people value. You can add another place now or come back later (via the button in the top right)',
                            '2_title': ' Great — your personal map is starting to take shape',
                            '2_text': 'Each place you add helps make visible what deserves protection. You can add another place now or come back later (via the button in the top right',
                            '3_title': 'Thank you! Your contribution is already providing valuable insights into nature and landscape',
                            '3_text': 'Adding one more place will complete your map — but you can also continue later (via the button in the top right)',
                            '4_title': 'Wonderful — your personal map is now complete!',
                            '4_text': 'Your contribution helps researchers and managers better understand which places people want to preserve and protect. You will soon see an overview of your places. First, we have one short question about possible financial support for your areas'
                        }
        */
        finished: {
          '1_title': 'Thank you! Your first place is now on the map',
          '1_text': 'Even this first contribution already helps us better understand which natural places people value.',
          '2_title': ' Great — your personal map is starting to take shape',
          '2_text': 'Each place you add helps make visible what deserves protection.',
          '3_title': 'Thank you! Your contribution is already providing valuable insights into nature and landscape',
          '3_text': 'Adding one more place will complete your map.',
          '4_title': 'Wonderful — your personal map is now complete!',
          '4_text': 'Your contribution helps researchers and managers better understand which places people want to preserve and protect. You will soon see an overview of your places. First, we have one short question about possible financial support for your areas'
        }
      },
      _edit: {
        title: 'Update area'
      },
      welcome: {
        title: 'Draw areas and answer questions',
        subtitle: 'Mark four nature places at different scales and share why they matter to you.',
        sheet_text: 'See the overview below. Press Next to draw your first neighbourhood area.',
        how_it_works_title: 'What you do at each level',
        step_draw: 'Mark an area on the map',
        step_questions: 'Answer questions about your place',
        step_next_level: 'Repeat for 4 scales',
        journey_title: 'Four scales, four places',
        video_caption: 'Short guide on how to draw an area'
      },
      welcome_v3: {
        greeting: 'Welcome to Greenmapper Friends',
        title: 'Mark your nature place',
        intro: 'Mark places with greenery, water, or landscape that you find attractive, valuable, or important.',
        levels_title: 'Four scales',
        levels_intro: 'Choose one place at each level.',
        checklist_title: 'What you do at each level',
        step_draw: 'Draw the place as an area on the map.',
        step_adjust: 'Adjust the shape and confirm the area.',
        step_questions: 'Answer a few questions about why this place matters to you.',
        step_repeat: 'Repeat these steps for the next scale level.',
        repeat_hint: 'You start in your neighborhood. After the questions, continue with region, country, and world.',
        start_btn: 'Start with Neighborhood'
      },
      welcome_v4: {
        title: 'Mark your nature place',
        title_next: 'Next place: {level}',
        intro: 'Mark places with greenery, water, or landscape that you find attractive, valuable, or important.',
        intro_next: 'Continue with {level}. Mark a place with greenery, water, or landscape that you find attractive, valuable, or important.',
        levels_title: 'Four scales',
        checklist_title: 'What you do at each level',
        start_badge: 'Start',
        now_badge: 'Now',
        done_badge: 'Done',
        progress: 'Place {current} of 4',
        start_btn: 'Start with {level}',
        continue_btn: 'Continue with {level}'
      }
    },
    edit_area: {
      title: 'Update area'
    },
    funding: {
      title: 'Virtual Nature & Community funds',
      nav_intro: 'Introduction',
      nav_amount: 'Amount',
      nav_locations: 'Locations',
      nav_objectives: 'Objectives',
      nav_finalize: 'Finalize',
      intro1: 'Hi!',
      intro2: 'Thank you for joining the Greenmapper experiment on nature funding.',
      intro3: 'In this section you use a <b>Virtual Nature & Community Fund</b>. You show how you would allocate a <b>hypothetical</b> yearly nature budget — <b>without actually paying</b>. Together with other participants, this helps managers and policy makers understand what people find important.',
      intro4: '<h6>How it works in 3 steps:</h6>',
      step1: 'Confirm your total yearly nature budget',
      step2: 'Allocate it across your 4 areas',
      step3: 'Allocate per area across goals: biodiversity, landscape, sustainable business, culture, other',
      caption: 'Trunk = area • Branches = goals • Apples = example projects.',
      intro5: '<b>Practical</b>: 5–8 min • anonymous • no right/wrong answers.',
      intro6: 'As a thank you, <b>we donate €5 to nature on Texel </b> after you complete this section.',
      amount1: 'Virtual funding amount',
      amount2: 'What would you — if it were really possible — like to spend per year on your favorite natural areas?It concerns a fictitious amount, but try to choose a figure that feels realistic to you.',
      amount3: 'Enter your (virtual) annual nature budget below.',
      amount4: 'Could you briefly explain why you chose this amount? For example, what you find important to support, or how you decided on this amount.',
      amount5: 'yearly budget',
      max: 'Maximun amount 5000 euro',
      min: 'Minimun amount 1 euro',
      locations1: 'Allocate your budget across your favorite natural areas',
      locations2: 'Indicate how you would divide your chosen (virtual) budget among the Virtual Nature and Community Funds of your favorite natural areas.',
      locations3: 'Could you briefly explain how you made your distribution? Why did you choose to divide it this way?',
      objectives1: 'Budget allocation between funding objectives',
      objectives2: 'Here you can see your distribution across the Virtual Nature and Community Funds for your area. You can do this for your favorite areas in your neighborhood, region, country, and worldwide. Indicate how you would divide your budget across the four goals',
      objectives2a: 'Would you like to support something that does not fit within these categories? Then write it at the bottom under “Other, namely…” and allocate part of your budget to it.',
      objectives3: 'Could you briefly explain how you made your distribution? Why did you choose to divide it this way?',
      biodiversity_title: 'Biodiversity conservation',
      biodiversity_text: 'A rich biodiversity supports ecosystem functioning and is crucial for supporting all life on earth. Biodiversity conservation projects aim to enhance or conserve biodiversity values, often in a local context. Such projects can aim to improve soil and water quality or for instance the placement of nest boxes for birds.',
      ALC_title: 'Landscape quality and view',
      ALC_text: 'Landscape scenery relates to the view and enjoyment of a landscape.  A landscape scenery project can be about protecting or restoring landscape elements like hedge rows, rewilding the landscape or creating hiking routes or biking lanes across the landscape.',
      SUSBUS_title: 'Sustainable entrepreneurship',
      SUSBUS_text: 'Sustainable businesses engage in their economic activities without generating negative effects for their (local) environment. Sustainable business projects might relate to the transitioning of a conventional farm to organic or nature friendly farming. It can also refer to the creation of a network of local firms and organizations that reduce waste and pollution in an integrated manner.',
      finalize1: '<b>Thank you!</b><br> Thank you for participating in this study on nature financing by the University of Groningen. Your answers are valuable. Click <b>Save</b> to record your responses.',
      finalize1A: '<b>Hooray!</b><br> You have earned €10 for nature projects on Texel. Thank you — your contribution helps us understand how people want to support nature.',
      finalize1B: '<b>What happens next?</b><br> You will now go to the Greenmapper Friends community ‘National Park Dunes of Texel’ for part 3. There, you will review six real funding requests. For each project, indicate whether you support it and explain why.\n' + 'Your own contribution in this experiment is fictitious, but the €10 and €5 donations made on your behalf are real.',
      finalize1C: '<b>Extra reward for Texel</b><br> If you respond to all six requests, Greenmapper will donate an additional €5. Every response counts! After responding to all six requests, you will automatically be entered into the prize draw.',
      finalize2: 'Please be reminded that it is possible to retract your submitted data without any consequences. If you wish to do so, or have any other questions regarding the research, please send an e-mail to',
      cultural_title: 'Culture and community life',
      cultural_text: 'Natural areas may also have a cultural heritage or other cultural aspects included within them. For instance if they contain historical  buildings or monuments or if certain cultural events are related to them. Cultural projects relate to the organisation of (musical) events, educational trips or the conservation of landed estates.',
      other_title: 'Other',
      other_text: 'Would you like to fund something else in your favourite natural area, but this was not mentioned above? Please name it yourself! You can use this slider to indicate how much of your budget you would allocate to it. This is not required, only if you think of something that does not belong to the previous categories of funding objectives.',
      placeholder: 'Other namely..'
    }
  },
  drawer: {
    area_section: 'Discover',
    my_section: 'My overview',
    other_section: 'Other',
    edit_funding: 'My Nature Budget',
    per_year: '/year',
    messages: 'Messages'
  },
  mail: {
    inbox: 'Inbox',
    outbox: 'Sent',
    compose: 'Compose'
  },
  gender: {
    male: 'Male',
    female: 'Female',
    other: 'Other'
  },
  education: {
    1: 'Less than highschool',
    2: 'High school graduate',
    3: 'Some college,no degree',
    4: 'Associate\'s degree',
    5: 'Bachelors degree',
    6: 'Master\'s degree',
    7: 'Professional school degree',
    8: 'Doctorate degree'
  },
  texel: {
    'continue-funding-1': 'You have recently registered for Greenmapper Friends. Thank you for your willingness to participate in this study on financial support for nature. In addition to your valuable answers for research purposes, we will donate €15 per completed participation to nature projects on Texel (up to a maximum of €2,000). The experiment takes between 5 and 10 minutes. Please make sure to respond to all virtual funding requests in the second part of the study in order to complete the study.',
    'continue-funding-2': 'Click on “continue” to be taken to the introduction of the study.',
    'continue-funding-3': 'We would like to sincerely thank you for your valuable participation in the Greenmapper Friends platform.',
    'continue-register-1': 'You recently started the registration process for Greenmapper Friends but have not yet completed it. Thank you for your willingness to finish your registration. Your input about your favorite nature is of great importance to researchers and policymakers.',
    'continue-register-2': 'Click on “continue” to resume your registration process.',
    'continue-register-3': 'We would like to sincerely thank you for your valuable participation in the Greenmapper Friends platform.'
  },
  video: {
    'draw_popup_title_1': 'Neighborhood',
    'draw_popup_subtitle_1': 'Within 2km of home',
    'draw_popup_text_1': 'This map shows an area of 2km around your place of residence. Mark a nature-related spot within this 2km that is attractive, valuable, or important to you. If you do not know of a spot within the 2km circle, please mark an area as close to it as possible.',
    'draw_popup_title_2': 'Region',
    'draw_popup_subtitle_2': 'Within 20km of home',
    'draw_popup_text_2': 'This map shows an area of 20km around your place of residence. Mark a nature-related spot within this 20km that is attractive, valuable, and important to you.',
    'draw_popup_title_3': 'Country',
    'draw_popup_subtitle_3': 'Entire country',
    'draw_popup_text_3': 'This map shows a map of the Netherlands. Mark nature-related a spot on this map that is attractive, valuable, or important to you.',
    'draw_popup_title_4': 'World',
    'draw_popup_subtitle_4': 'Worldwide',
    'draw_popup_text_4': 'This map shows a map of the world. Mark a nature-related spot on this map that is attractive, valuable, or important to you.',
    'draw_popup_video': 'Below is a short video (30s) on how to draw an area.',
    'step1_helper': 'Drag the map so your attractive place sits fully inside the clear circle. Zoom until the circle covers it completely.',
    'step2_helper': 'Looks good? Continue — or optionally drag the points so the shape covers your place more accurately.',
    'clamp_hint_default': 'This stays within {distance}. The next question lets you go further.',
    'scale_badge_radius': 'Within {distance} of home',
    'scale_badge_full': 'On the map of {name}',
    'level_up_toast': 'Area enlarged to {distance}'
  }
  /*
      pbl: {
          'draw_popup_title_1': 'Buurt',
          'draw_popup_subtitle_1': 'Schaal: 2km',
          'draw_popup_text_1': 'Deze kaart laat een gebied van 2km rondom uw woonplek zien. Markeer een natuur gerelateerde plek binnen deze 2km die voor u  aantrekkelijk, waardevol en belangrijk is.',
          'draw_popup_title_2': 'Leefomgeving',
          'draw_popup_subtitle_2': 'Schaal: 20km',
          'draw_popup_text_2': 'Deze kaart laat een gebied van 20km rondom uw woonplek zien. Markeer een plek binnen deze 20km die voor u aantrekkelijk, waardevol en belangrijk is.',
          'draw_popup_title_3': 'Land',
          'draw_popup_subtitle_3': 'Schaal: heel Nederland',
          'draw_popup_text_3': 'Deze kaart laat een kaart van Nederland zien. Markeer een plek op deze kaart die voor u aantrekkelijk, waardevol en belangrijk is.',
          'draw_popup_title_4': 'Wereld',
          'draw_popup_subtitle_4': 'Schaal: wereldwijd',
          'draw_popup_text_4': 'Deze kaart laat een kaart van de wereld zien. Markeer een plek op deze kaart die voor u aantrekkelijk, waardevol en belangrijk is.',
  
          '1_title': 'Geef een titel die het gebied weergeeft',
          '2_description': 'Omschrijf in uw eigen woorden wat dit gebied aantrekkelijk, waardevol of belangrijk voor je maakt. Gebruik zoveel woorden als u zelf wilt.',
          '3_rate': 'Waardeer dit gebied.',
  
          act_fun: '<b>Iets doen voor je plezier </b>(bv. wandelen, zwemmen, de hond uitlaten)',
          act_sport: '<b>Sporten</b> (bv. fietsen, mountainbiken, vissen)',
          act_meet: '<b>Naasten en bekenden ontmoeten</b> (bv. afspreken met vrienden, picknicken, spelen met de kinderen)',
          act_spot: '<b>Natuur bekijken</b> (bv. vogels spotten, planten of dieren bekijken)',
          act_gather: '<b>Voedsel plukken of jagen</b> (bv. bessen of kruiden plukken, jagen op wild)',
          act_work: '(Vrijwilligers)<b>werk</b> (bv. rondleidingen geven, bomen planten, meedoen aan een vogeltelling, oogsten van landbouwproducten)',
          act_relax: '<b>Ontspannen</b> (bv. rust opzoeken, lezen)',
          act_outside: '<b>Naar buiten gaan</b> (bv. zon of schaduw opzoeken)',
  
          '7_title': '~~~~~ TODO: no text in doc ~~~~~~~',
          '7_title_nav': '~~~~~ TODO: no text in doc ~~~~~~~',
  
          'people_title': 'Vind u dat <b>burgers</b> verantwoordelijk zijn voor dit gebied?',
          'local_title': 'Vindt u dat <b>lokale overheden</b> verantwoordelijk zijn voor dit gebied?',
          'federal_title': 'Vindt u dat de <b>Rijksoverheid</b> verantwoordelijk is voor dit gebied?',
          'business_title': 'Vindt u dat het <b>bedrijfsleven</b> verantwoordelijk is voor dit gebied?',
  
          '8_title': 'Hieronder staan uitspraken over verschillende aspecten die belangrijk kunnen zijn als je denkt over de natuur in dit gebied in de toekomst. Geef aan hoeveel prioriteit elk aspect volgens u zou moeten hebben.',
          '8_title_nav': 'Toekomst',
          'q_a': 'De natuur in dit gebied biedt mogelijkheden voor buitenrecreatie en sport',
          'q_b': 'Mensen kunnen genieten van de schoonheid van de natuur in dit gebied',
          'q_c': 'De natuur in dit gebied wordt beschermd voor het belang van de natuur zelf',
          'q_d': 'We blijven onze morele verantwoordelijkheid nemen om de natuur in dit gebied te beschermen',
          'q_e': 'De natuur in dit gebied wordt beschermd, ongeacht of dit de mens ten goede komt of niet',
          'q_f': 'De natuur in dit gebied draagt bij aan economische groei en werkgelegenheid ',
          'q_g': 'De natuur in dit gebied biedt mogelijkheden om goederen te oogsten zoals hout, bessen, paddenstoelen of vis',
          'q_h': 'De natuur in dit gebied draagt bij aan zingeving van ons leven',
          'q_i': 'De natuur in dit gebied biedt religieuze en spirituele waarden of ervaringen',
          'q_j': 'Mensen vinden een gevoel van verbondenheid met de natuur in dit gebied',
          'q_k': 'Mensen kunnen zich verbonden voelen met de bomen en dieren in dit gebied',
          'q_l': 'De natuur in dit gebied biedt mogelijkheden om bij te dragen aan de gezondheid van mensen',
  
          pbl_prio_7: '7 de hoogste prioriteit'
  
      }
  */

};